export default "/img/robot.png"